import { useIntl } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useWalletPartnerCollectibles } from '@capsicum/features/wallet/shared';

import { WalletCollectiblesCarousel } from '../../digital-collectibles';
import { SectionTitle, SectionWrapper } from '../WalletPartnerDetails.styled';

const WalletCollectiblesSection = ({ partnerId }: { partnerId: string }) => {
	const { $t } = useIntl();
	const { push } = useRouter();

	const { collectibles, isLoading } = useWalletPartnerCollectibles(partnerId);

	const handleClickDigitalCollectible = (collectibleId?: string) => {
		push(`/digital-collectibles/${collectibleId}`);
	};

	return (
		<SectionWrapper>
			<SectionTitle>{$t('wallet.partnerDetails.lockerRoom.collectibles.title')}</SectionTitle>

			<WalletCollectiblesCarousel
				collectibles={collectibles}
				isLoading={isLoading}
				onCollectibleClick={handleClickDigitalCollectible}
			/>
		</SectionWrapper>
	);
};

export { WalletCollectiblesSection };
